import React from 'react'
import PlaylistCard from '../course_playlists/PlaylistCard';
import { Grid } from '@mui/material';

// Child component for the player course section, it renders a list of cards each
// representing the playlists available for the currently selected course
const PlayerCoursePlaylistOverview = ({ playlists, course }) => {

    const playlistOverview = playlists.map((playlist, index) =>

        <Grid item xs={12} sm={6} md={3}>
            <PlaylistCard
                playlist={playlist}
                course={course}
            />
        </Grid>
    );

    return (
        <div>
            <Grid container spacing={6}>
                {playlistOverview}
            </Grid>
        </div>
    )
}

export default PlayerCoursePlaylistOverview
